import { SET_ADD_IN_PROCESS_NEW_DSR_POST, SET_ADDED_PROCESSING_DSR_POST, SET_REMOVE_IN_PROCESS_NEW_DSR_POST, SET_REMOVED_PROCESSING_DSR_POST } from "./dsr-ux-actions-types";

// 
export const setAddProcessingDsrPost = (p) => {
	return {
		type: SET_ADDED_PROCESSING_DSR_POST,
		payload: p
	};
};

export const setRemoveProcessingDsrPost = (p) => {
	return {
		type: SET_REMOVED_PROCESSING_DSR_POST,
		payload: p
	};
};


export const setAddProcessingNewDsrPost = (p) => {
	return {
		type: SET_ADD_IN_PROCESS_NEW_DSR_POST,
		payload: p
	};
};

export const setRemoveProcessingNewDsrPost = (p) => {
	return {
		type: SET_REMOVE_IN_PROCESS_NEW_DSR_POST,
		payload: p
	};
};
